<template>
  <div>
    <div class="review-input-form" v-if="isEditing">
      <div class="form-group">
        <div class="external-post-links-form">
          <p>メディアを選択してください</p>
          <select
            v-model="externalPostLinks.selectedMedia"
            class="form-control"
          >
            <option value="">選択してください</option>
            <option
              v-for="media in mediaList"
              :key="media"
              :value="media"
            >{{ media }}</option>
          </select>
          <label for="" class="nofollow">
            <input type="checkbox" v-model="externalPostLinks.nofollow">
            <p>nofollow をつける</p>
          </label>
        </div>

        <label class="external-post-links-form" v-if="externalPostLinks.selectedMedia">
          <p>記事ID一覧</p>
          <small>※ 改行区切りで記事IDを記載してください</small>
          <textarea :placeholder="`1\n2\n3`" rows="4" v-model="formText" />
          <ul class="link-preview">
            <li
              v-for="(url, i) in urls"
              :key="i"
              class="link-preview__item"
            >
              <a :href="url" target="_blank">{{
                url
              }}</a>
            </li>
          </ul>
        </label>
        <div class="form-group__footer">
          <a class="btn-green" @click="onEndEdit()">追加</a>
          <a class="btn-green" @click="onDeleteInput()">削除</a>
        </div>
      </div>
    </div>
    <div class="input-preview" v-else>
      <p>他メディア記事リスト</p>
      <ul class="link-preview">
        <li
          v-for="(url, i) in urls"
          :key="i"
          class="link-preview__item"
        >
          <a :href="url" target="_blank">{{
            url
          }}</a>
        </li>
      </ul>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import FooterMenu from '../input-footer-menu.vue';

export default {
  name: 'ExternalPostLinksEditor',
  components: {
    FooterMenu,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    const mediaList = [
      "enjoy-night",
      "fuzolution",
      "gokuraku-lovers",
      "happy-travel",
      "heaven-heaven",
      "maruhigoodslabo",
      "midnight-angel",
      "onenight-story",
      "otona-asobiba",
      "pakokatsu-navi",
      "purozoku",
      "trip-partner",
      "ura-info",
    ]

    return {
      isEditing: false,
      formText: this.value.externalPosts.join('\n'),
      mediaList,
      externalPostLinks: {
        nofollow: this.value.nofollow,
        selectedMedia: this.value.selectedMedia || '',
        externalPosts: this.value.externalPosts || [],
      },
    };
  },
  computed: {
    bodyJSON() {
      return {
        value: this.externalPostLinks,
        action: 'external-post-links',
        id: this.id,
      };
    },
    postIDs() {
      return this.formText
        .split('\n')
        .map((id) => id.trim())
        .filter((id) => id !== '');
    },
    urls() {
     return this.postIDs.map((id) => `https://${this.externalPostLinks.selectedMedia}.jp/${id}`)
    }
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.externalPostLinks.externalPosts = this.postIDs;
      this.formText = this.externalPostLinks.externalPosts.join('\n');
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 10px;
    }
  }
}

.external-post-links-form {
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    font-size: 14px;
  }
}


.input-preview {
  font-family: sans-serif;

  p {
    font-size: 14px;
    margin-bottom: 8px;
  }
}

.link-preview {
  font-size: 12px;

  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.nofollow {
  display: flex;
  align-items: center;
  gap: 2px;

  > p {
    font-size: 12px;
  }
}
</style>
